// @ts-nocheck
import * as types from '../../mutation-types';
import config from '@/config';
import * as data from './data';
import actions from './actions';
import { find } from 'lodash-es';

const state = {
  filteredPostalCodes: null,
  availableConditionTypes: data.CONDITION_TYPES,
  availableShoreTypes: data.SHORE_TYPES,
  availableShorePrivileges: data.SHORE_PRIVILEGES,
  validationErrors: data.VALIDATION_ERRORS,
  errorPageData: data.ERROR_MESSAGES.defaultMessages[404],
  featureGroups: config.FEATURE_GROUPS,
  autocompleteError: false,
  landingPages: [],
  currentNews: [],
  careerStories: [],
};

const mutations = {
  [types.SET_ERROR_PAGE_DATA](state, errorState) {
    const code = data.ERROR_CODES.includes(errorState.errorCode) ? errorState.errorCode : 404;
    const page = Object.values(config.PAGE_NAMES).includes(errorState.errorPageName)
      ? errorState.errorPageName
      : 'defaultMessages';
    const content = data.ERROR_MESSAGES[page][code];
    state.errorPageData.errorCode = code;
    state.errorPageData.message = content.message;
    state.errorPageData.backButtonText = content.backButtonText;
    state.errorPageData.returnUrl = content.returnUrl;
    state.errorPageData.targetUrl = errorState.targetUrl;
  },
  [types.SET_AUTOCOMPLETE_ERROR](state) {
    state.autocompleteError = true;
  },
  [types.UNSET_AUTOCOMPLETE_ERROR](state) {
    state.autocompleteError = false;
  },
};

const getters = {
  postalCodeMatches: (state) => state.filteredPostalCodes,
  availableConditionTypes: (state) => state.availableConditionTypes,
  availableShoreTypes: (state) => state.availableShoreTypes,
  availableShorePrivileges: (state) => state.availableShorePrivileges,
  validationErrors: (state) => state.validationErrors,
  errorPageData: (state) => state.errorPageData,
  autocompleteError: (state) => state.autocompleteError,
  landingPages: (state) => state.landingPages,
  // FEATURE GROUPS
  getFeatureGroups: (state) => state.featureGroups,
  findFeatureGroupById: (state) => (id) => find(state.featureGroups, { id }),
  findFeatureGroupRouteWithId: (state) => (id) => {
    const group = find(state.featureGroups, { id });
    return group ? group.pathName : null;
  },
  currentNews: (state) => state.currentNews,
  careerStories: (state) => state.careerStories,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
